<template>
  <div class="store-results">
    <div class="store-results__map">
      <Google-Maps
        :google-maps-url="googleMapsUrl"
        :locations="results"
        :active-marker-id="activeMarkerId"
        :default-zoom="defaultZoom"
        :default-lat="defaultLat"
        :default-long="defaultLong"
      />
    </div>

    <div class="store-results__list">
      <div
        v-if="loading"
        aria-live="polite"
        class="store-results__list__loading"
      >
        <span class="is-sr-only">Loading stores</span>
        <slot name="loading-icon" />
      </div>

      <div
        v-if="!results.length && !loading"
        class="store-results__list__no-results"
      >
        <div v-if="!noResults">
          <slot name="results-arrow" />
          <p class="paragraph">
            <slot name="enter-info-copy" />
          </p>
        </div>
        <div v-if="noResults">
          <slot name="no-locations-fould" />
        </div>
      </div>

      <div
        v-if="results.length && !loading"
        class="store-results__list__result"
      >
        <div class="results-title section-subheading">
          <slot name="results-title-copy" />
          <span class="results-title-product">"{{ selectedProduct.value }}"</span>:
        </div>
        <ol class="locations">
          <li
            v-for="(result, i) in results"
            :key="i"
            class="location"
          >
            <a
              :id="result.store_id"
              class="location__name"
              @click.prevent="setActiveMarker(result)"
              v-text="result.name"
            />
            <p>{{ result.state ? result.address + ', ' + result.state : result.address }}</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
  import GoogleMaps from '../GoogleMaps/GoogleMaps';
  export default {
    name: 'StoreResults',
    components: {
      GoogleMaps
    },
    props: {
      selectedProduct: { type: Object, required: false, default: null },
      results: { type: Array, required: true },
      noResults: { type: Boolean, required: false, default: false },
      loading: { type: Boolean, required: false, default: false },
      googleMapsUrl: { type: String, required: true },
      defaultZoom: { type: Number, required: true },
      defaultLat: { type: String, required: true },
      defaultLong: { type: String, required: true },
    },
    data() {
      return {
        activeMarkerId: null
      };
    },
    methods: {
      setActiveMarker(marker) {
        this.activeMarkerId = marker.store_id;
      }
    }
  };
</script>
